import { collection, doc, onSnapshot, orderBy, query, limit, writeBatch } from 'firebase/firestore';
import { db } from './firebaseService';
import { AppNotification } from '../types';

export function subscribeToNotifications(
  uid: string,
  callback: (notifs: AppNotification[]) => void
): () => void {
  const q = query(
    collection(db, 'users', uid, 'notifications'),
    orderBy('createdAt', 'desc'),
    limit(50)
  );
  return onSnapshot(q, snap => {
    callback(snap.docs.map(d => ({ id: d.id, ...d.data() } as AppNotification)));
  }, () => callback([]));
}

export async function markAllNotificationsAsRead(uid: string, ids: string[]): Promise<void> {
  if (!ids.length) return;
  const batch = writeBatch(db);
  ids.forEach(id =>
    batch.update(doc(db, 'users', uid, 'notifications', id), { isRead: true })
  );
  await batch.commit();
}

export async function markNotificationAsRead(uid: string, notifId: string): Promise<void> {
  const batch = writeBatch(db);
  batch.update(doc(db, 'users', uid, 'notifications', notifId), { isRead: true });
  await batch.commit();
}
